const html = require("choo/html");
const PanelElement = require("../elements/panel.js");
const CarouselElement = require("../elements/carousel.js");
const InputOption = require("../elements/inputoption.js");
const InputText = require("../elements/inputtext.js");
const InputSlider = require("../elements/inputslider.js");
const InputSprite = require("../elements/inputsprite.js");
const Button = require("../elements/button.js");
const ButtonIcon = require("../elements/buttonicon.js");
const itemsPerPage = 4;
const PARAMETERS = [];
const BOOL_OPTIONS = [
  { value: "true", label: "true" },
  { value: "false", label: "false" },
];

const KEY_OPTIONS = [
  {
    label: "left arrow",
    value: "left arrow",
  },
  {
    label: "right arrow",
    value: "right arrow",
  },
  {
    label: "up arrow",
    value: "up arrow",
  },
  {
    label: "down arrow",
    value: "down arrow",
  },
  {
    label: "space",
    value: "space",
  },
  {
    label: "w",
    value: "w",
  },
  {
    label: "a",
    value: "a",
  },
  {
    label: "s",
    value: "s",
  },
  {
    label: "d",
    value: "d",
  },
  {
    label: "f",
    value: "f",
  },
  {
    label: "none",
    value: "none",
  },
];

function Tooltip({ content }) {
  return html` <div class="tooltip">${content}</div> `;
}

function generateListInput(variable, gameVariable, target, state, emit) {
  const { input } = gameVariable;
  const inputs = [];
  variable.value.forEach((value, index) => {
    let label = variable.name;
    if (index > 0) {
      label = null;
    }
    const commonProps = {
      ...input,
      label,
      value,
      onChange: () => emit("stop-changing-variable", target, variable),
      onInput: (e) =>
        emit("set-list-value", target, variable, index, e.target.value),
    };
    inputs.push(
      InputText({
        ...commonProps,
        disabled: state.selectedVariableId !== null || state.isMenuOpen,
        onKeyDown: (e) => e.stopPropagation(),
        onKeyUp: (e) => e.stopPropagation(),
      })
    );
  });
  inputs.push(
    new Button({
      text: "add value",
      onClick: () => emit("add-item-to-list", target, variable),
    })
  );
  return inputs;
}

function generateParameterInput(parameter, target, state, emit) {
  const { id, label } = parameter;
  const disabled = state.selectedVariableId !== null || state.isMenuOpen;

  switch (id) {
    /* 
    case "isActive":
      const options = [
        { value: false, label: "idle" },
        { value: true, label: "active" },
      ];
      let isActiveVariable = Object.values(target.variables).find(
        (v) => v.name === "is active?"
      );
      let amIActive;
      if (!isActiveVariable) {
        amIActive = false;
      } else {
        amIActive =
          isActiveVariable.value === true || isActiveVariable.value === "true";
      }
      return InputOption({
        label,
        options,
        selectedItem: amIActive,
        onChange: (index) =>
          emit("set-animation-state", target, options[index].value),
      });
      */

    case "currentCostume":
      const costumeNames = target.sprite.costumes.map((c) => c.name);
      const selectedItem = target.currentCostume;
      return InputOption({
        label,
        options: costumeNames.map((name) => ({ value: name, label: name })),
        selectedItem,
        onChange: (index) => emit("set-costume", target, index),
        disabled,
        id: target.isStage ? "current-backdrop" : "current-costume"
      });
    case "color":
      return InputSlider({
        label,
        value: target.effects.color,
        min: 0,
        max: 200,
        step: 1,
        id: "color-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "color", target, e.target.value),
        disabled,
      });

    case "brightness":
      return InputSlider({
        label,
        value: target.effects.brightness,
        min: -100,
        max: 100,
        step: 1,
        id: "brightness-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "brightness", target, e.target.value),
        disabled,
      });

    case "mosaic":
      return InputSlider({
        label,
        value: target.effects.mosaic,
        min: 0,
        max: 100,
        step: 1,
        id: "mosaic-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "mosaic", target, e.target.value),
        disabled,
      });

    case "pixelate":
      return InputSlider({
        label,
        value: target.effects.pixelate,
        min: 1,
        max: 100,
        step: 1,
        id: "pixelate-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "pixelate", target, e.target.value),
        disabled,
      });

    case "whirl":
      return InputSlider({
        label,
        value: target.effects.whirl,
        min: -100,
        max: 100,
        step: 1,
        id: "whirl-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "whirl", target, e.target.value),
        disabled,
      });

    /* 2025-08-26: LIAM: I'm disabling this because it doesn't really work.
    case "fisheye":
      return InputSlider({
        label,
        value: target.effects.fisheye,
        min: 0,
        max: 10,
        step: 1,
        id: "fisheye-slider",
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "fisheye", target, e.target.value),
        disabled,
      });
     */

    case "ghost": {
      let value = target.effects.ghost;
      if (!state.isGamePlaying) {
        const hiddenMe = state.hiddenTargets.find((t) => t.id === target.id);
        if (hiddenMe) {
          value = hiddenMe.ghost;
        }
      }
      return InputSlider({
        label,
        value,
        min: 0,
        max: 100,
        step: 1,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) =>
          emit("set-graphic-effect", "ghost", target, e.target.value),
        disabled,
      });
    }

    /* 2025-08-12: LIAM: I'm disabling this for now because it can lead to pieces being hidden and then getting lost. Users cannot re-show a piece if they've hidden it and then selected something else. Furthermore, if a user wants a piece to be hidden they can just set GHOST to 100%
    case "visible": {
      const options = [
        { value: true, label: "visible" },
        { value: false, label: "hidden" },
      ];
      let value = target.visible;
      if (!state.isGamePlaying) {
        const hiddenMe = state.hiddenTargets.find((t) => t.id === target.id);
        if (hiddenMe) {
          value = false;
        }
      }
      const selectedItem = options.indexOf(
        options.find((o) => o.value === value)
      );
      return InputOption({
        label,
        options,
        selectedItem,
        onChange: (index) => emit("set-visible", target, options[index].value),
        disabled,
      });
    }
    */

    case "layer":
      return InputSlider({
        label,
        value: target.getLayerOrder(),
        min: 1,
        max: state.vm.runtime.targets.length - 1,
        step: 1,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) => emit("set-layer-order", target, e.target.value),
        disabled,
        id: "layer-slider",
      });

    case "xPosition":
      return InputSlider({
        label,
        value: Math.round(target.x),
        min: -240,
        max: 240,
        step: 1,
        shiftStep: 5,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) => emit("set-x-position", target, e.target.value),
        disabled,
        id: "x-position-slider",
      });
      
    case "yPosition":
      return InputSlider({
        label,
        value: Math.round(target.y),
        min: -180,
        max: 180,
        step: 1,
        shiftStep: 5,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) => emit("set-y-position", target, e.target.value),
        disabled,
        id: "y-position-slider",
      });
    case "direction":
      return InputSlider({
        label,
        value: target.direction,
        min: 0,
        max: 360,
        step: 1,
        shiftStep: 15,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) => emit("set-direction", target, e.target.value),
        disabled,
        id: "direction-slider",
      });
    case "size":
      return InputSlider({
        label,
        value: target.size,
        min: 1,
        max: 1000,
        step: 1,
        shiftStep: 10,
        onChange: () => emit("stop-changing-variable", target, parameter),
        onInput: (e) => emit("set-size", target, e.target.value),
        disabled,
        id: "size-slider",
      });
  }
}

function generateInputElement(gameVariable, target, state, emit) {
  const { input, id } = gameVariable;
  let variable;
  if (target) {
    variable = target.variables[id];
  } else {
    gameVariable.name = gameVariable.variableName;
    variable = gameVariable;
  }
  function setVariable(value) {
    if (gameVariable.input.onchange) {
      emit(
        gameVariable.input.onchange,
        target,
        variable,
        value,
        input.instanceParam
      );
    } else {
      emit("set-variable", target, variable, value, input.instanceParam);
    }
  }
  let label = variable.name;

  // if (state.selectedTargetId !== target.id) {
  //    label = `${gameVariable.spriteName}: ${variable.name}`;
  //  }
  const commonProps = {
    ...input,
    label,
    tooltip: Tooltip({ content: gameVariable.tooltip }),
    value: variable.value,
    disabled: state.selectedVariableId !== null || state.isMenuOpen,
    onChange: () => emit("stop-changing-variable", target, variable),
    onInput: (e) => setVariable(e.target.value),
  };
  if (input.type === "slider") {
    return InputSlider({ ...commonProps });
  }
  if (
    input.type === "option" ||
    input.type === "key" ||
    input.type === "boolean"
  ) {
    let { options } = input;
    if (input.type === "key") {
      options = KEY_OPTIONS;
    } else if (input.type === "boolean") {
      options = BOOL_OPTIONS;
    }

    let selectedItem = options.findIndex((o) => o.value === variable.value);
    if (!selectedItem) {
      selectedItem = 0;
    }
    if (options.length === 0) {
      return null;
    }
    return InputOption({
      ...commonProps,
      options,
      selectedItem,
      onChange: (index) => {
        setVariable(options[index].value);
        emit("stop-changing-variable", target, variable);
      },
    });
  }
  if (input.type === "text") {
    return InputText({
      ...commonProps,
      onKeyDown: (e) => e.stopPropagation(),
      onKeyUp: (e) => e.stopPropagation(),
    });
  }
  if (input.type === "sprite") {
    if (state.selectedVariableId === id) {
      commonProps.value = "NO PIECE SELECTED";
      commonProps.disabled = false;
    }
    return InputSprite({
      ...commonProps,
      onSelect: () => emit("start-setting-sprite-variable", variable.id),
    });
  }
  return null;
}

function paginateInputs(inputs) {
  const pages = [];
  let pageIndex = 0;
  pages[0] = [];
  for (let i = 0; i < inputs.length; i++) {
    if (pages[pageIndex].length === itemsPerPage) {
      pageIndex += 1;
      pages[pageIndex] = [];
    }
    pages[pageIndex].push(inputs[i]);
  }

  const items = pages.map((p) => html`<div class="info">${p}</div>`);
  return items;
}

function getExposedVariableWithIds(gameVariables, inTarget) {
  return gameVariables.reduce((acc, exposedVariable) => {
    let target;
    if (exposedVariable.spriteName === inTarget.sprite.name) {
      target = inTarget;
    } else {
      target = inTarget.runtime.targets.find(
        (t) => t.sprite.name === exposedVariable.spriteName
      );
    }
    // Find variable in scratch sprite
    const gameVariable = Object.values(target.variables).find(
      (v) => v.name === exposedVariable.variableName
    );
    if (!gameVariable) {
      target.lookupOrCreateVariable(
        exposedVariable.variableName,
        exposedVariable.variableName
      );
    }
    // Include the scratch variable id on exposed variable info
    if (gameVariable) {
      exposedVariable.id = gameVariable.id;
      acc.push(exposedVariable);
    }
    return acc;
  }, []);
}

function getExposedProjectVariables(
  target,
  projectVars,
  glitchApplications,
  availableGlitches
) {
  let keyVariables = [];
  let exposedVariables = [];
  if (!projectVars) {
    projectVars = [];
  }
  if (target.isStage) {
    exposedVariables = projectVars.filter((v) => v.spriteName === "Stage");
 /*   keyVariables = getKeyInputVariables(
      glitchApplications,
      availableGlitches,
      target.runtime
    );
    */
  } else {
    exposedVariables = projectVars.filter(
      (v) => v.spriteName === target.sprite.name
    );
  }
  const varsWithIds = getExposedVariableWithIds(exposedVariables, target);
  return varsWithIds.concat(keyVariables);
}

function getKeyInputVariables(glitchApplications, availableGlitches, runtime) {
  const glitchesWithKeyVars = availableGlitches.filter((g) =>
    g.exposedVariables.find((v) => v.input.type === "key")
  );
  const keyVarApplications = glitchApplications.filter((g) =>
    glitchesWithKeyVars.find((_g) => _g.id === g.glitchId)
  );
  let glitchVars = [];
  keyVarApplications.forEach((glitchApplication) => {
    const glitch = availableGlitches.find(
      (g) => g.id === glitchApplication.glitchId
    );
    const t = runtime.targets.find((t) => t.id === glitchApplication.targetId);
    glitchVars = glitchVars.concat(
      getGlitchVariables(t, glitchApplication, availableGlitches)
    );
  });
  glitchVars = glitchVars.filter((gv) => gv.input.type === "key");
  return glitchVars;
}

function getGlitchVariables(target, glitchApplication, availableGlitches) {
  if (!target || !glitchApplication) {
    return [];
  }
  const glitch = availableGlitches.find(
    (g) => g.id === glitchApplication.glitchId
  );
  const exposedVariables = glitch.exposedVariables
    .filter((v) => v.spriteName === "$glitch_target")
    .map((v) => ({
      ...v,
      spriteName: target.sprite.name,
    }));
  return getExposedVariableWithIds(exposedVariables, target);
}

function getGameVariables(target, addedParts) {
  let exposedVariables;
  const selectedPart = addedParts.find(
    (p) => p.spriteName === target.sprite.name
  );
  if (selectedPart) {
    ({ exposedVariables } = selectedPart);
  }
  if (exposedVariables) {
    exposedVariables = exposedVariables.filter(
      (v) => v.spriteName === target.sprite.name
    );
  } else {
    exposedVariables = [];
  }
  return getExposedVariableWithIds(exposedVariables, target);
}

function getAltVariables(target, glitchApplications, availableGlitches) {
  if (target.isStage) {
    return [];
  }
  const altVars = [];
  glitchApplications.forEach((glitchApplication) => {
    const glitch = availableGlitches.find(
      (g) => g.id === glitchApplication.glitchId
    );
    const exposedVariables = glitch.exposedVariables
      .filter((v) => v.spriteName === "$other_sprites")
      .map((v) => ({
        ...v,
        spriteName: target.sprite.name,
      }));
    exposedVariables.forEach((v) => {
      if (!altVars.find((altVar) => altVar.variableName === v.variableName)) {
        altVars.push(v);
      }
    });
  });

  return getExposedVariableWithIds(altVars, target);
}

function getPhysicsParameters(target) {
  if (target.isStage) {
    return [];
  }

  let targetParameters = PARAMETERS.map((param) => ({
    ...param,
    spriteName: target.sprite.name,
  }));

  return getExposedVariableWithIds(targetParameters, target);
}

function shouldWeShowPanel(state) {
  if (state.selectedGlitchApplicationId) {
    return true;
  }
  if (state.selectedTargetId && !state.playingTutorial) {
    return true;
  }
  if (state.isFullscreen) {
    return true;
  }
  return false;
}

module.exports = function VariablesPanel(state, emit) {
  function getTargetingEntries(target) {
    if (!target || target.isStage) return [];
    const entries = [];
    // Map applications by source original id
    const appsByTargetId = state.glitchApplications.reduce((m, ga) => {
      if (!m[ga.targetId]) m[ga.targetId] = [];
      m[ga.targetId].push(ga);
      return m;
    }, {});
    // Iterate all sprite targets
    state.vm.runtime.targets.forEach((source) => {
      if (!source || source.isStage) return;
      const [original] = source.sprite.clones;
      const apps = appsByTargetId[original && original.id] || [];
      if (apps.length === 0) return;
      apps.forEach((ga) => {
        const glitch = state.availableGlitches.find((g) => g.id === ga.glitchId);
        if (!glitch || !glitch.exposedVariables) return;
        // sprite selectors for the glitch target
        glitch.exposedVariables
          .filter((v) => v.input && v.input.type === "sprite")
          .forEach((v) => {
            const srcVar = Object.values(source.variables).find(
              (sv) => sv.name === v.variableName
            );
            if (srcVar && srcVar.value === target.sprite.name) {
              entries.push({
                sourceName: source.sprite.name,
                stickerId: glitch.id,
                stickerTitle: glitch.title || glitch.id,
                variableName: v.variableName,
              });
            }
          });
      });
    });
    // Deduplicate by source + sticker + variableName
    const seen = new Set();
    return entries.filter((e) => {
      const key = `${e.sourceName}|${e.stickerId}|${e.variableName}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function renderTargetingBlock(target) {
    if (state.selectedGlitchApplicationId) return null;
    const items = getTargetingEntries(target);
    if (items.length === 0) return null;
    // Build multiple VariablesPanel items (one per entry) to avoid split rows
    const blocks = items.map((it) => {
      const glitch = state.availableGlitches.find((g) => g.id === it.stickerId);
      const iconClass = glitch && glitch.icon ? `icon icon-${glitch.icon}` : '';
      const colorClass = glitch && glitch.color ? glitch.color : '';
      const glitchApplication = state.glitchApplications.find(
        (g) => g.glitchId === it.stickerId && state.vm.runtime.targets.find(t => t.sprite && t.sprite.name === it.sourceName && t.isOriginal ? t.id : null)
      );
      const source = state.vm.runtime.targets.find((t) => t.sprite && t.sprite.name === it.sourceName);
      const [original] = source ? source.sprite.clones : [null];
      const ga = state.glitchApplications.find(
        (g) => g.glitchId === it.stickerId && g.targetId === (original && original.id)
      );
      const onClick = () => {
        if (source) emit('select-target', source.id);
        if (ga) emit('select-glitch-application', ga.id);
      };
      return html`
        <div class="info">
          <div class="input input-sprite">
            <label>targeting this piece</label>
            <div class="input-area" onclick=${onClick}>
              <i class="icon ${colorClass} ${iconClass}" style="margin-right: var(--size-2);"></i>
              ${it.stickerTitle}
            </div>
          </div>
        </div>`;
    });
    return blocks;
  }
  function getInputPanelDataForGlitch() {
    const glitch = state.availableGlitches.find(
      (g) => g.id === state.selectedGlitchId
    );
    const color = glitch.color;
    const uniqueVariables = [];
    const variablesToDisplay = glitch.exposedVariables;
    const parametersToDisplay = [];
    return { color, uniqueVariables, variablesToDisplay, parametersToDisplay };
  }

  function getInputPanelDataForTarget() {
    let color = "purple";
    const uniqueVariables = [];
    let variablesToDisplay = [];

    const parametersToDisplay = [];
    if (state.selectedGlitchApplicationId) {
      const glitchApplication = state.glitchApplications.find(
        (g) => g.id === state.selectedGlitchApplicationId
      );
      const glitch = state.availableGlitches.find(
        (g) => g.id === glitchApplication.glitchId
      );

      if (glitch.id === "effects") {
        parametersToDisplay.push(
          { id: "color", label: "color" },
          { id: "brightness", label: "brightness" },
          { id: "mosaic", label: "mosiac" },
          { id: "pixelate", label: "pixelate" },
          { id: "whirl", label: "whirl" },
          { id: "fisheye", label: "fisheye" }
        );
      } else if (glitch.id === "visibility") {
        parametersToDisplay.push(
          { id: "ghost", label: "ghost" },
          { id: "visible", label: "visible" },
          { id: "layer", label: "layer" }
        );
      }
      ({ color } = glitch);
      variablesToDisplay = getGlitchVariables(
        target,
        glitchApplication,
        state.availableGlitches
      );
    } else {
      if (target.sprite.costumes.length > 1 && target.isStage) {
        parametersToDisplay.push({
          id: "currentCostume",
          label: "Current Backdrop",
        });
      } else {
        parametersToDisplay.push({ id: "xPosition", label: "X Position" });
        parametersToDisplay.push({ id: "yPosition", label: "Y Position" });
        parametersToDisplay.push({ id: "direction", label: "Direction" });
        parametersToDisplay.push({ id: "size", label: "Size" });
      }
      const spriteVariables = getGameVariables(target, state.addedParts);
      const altVariables = getAltVariables(
        target,
        state.glitchApplications,
        state.availableGlitches
      );
      const params = getPhysicsParameters(target);
      variablesToDisplay = spriteVariables.concat(params).concat(altVariables);
      if (target.isStage || state.isFullscreen) {
        variablesToDisplay = getExposedProjectVariables(
          target,
          state.projectMetadata.exposedVariables,
          state.glitchApplications,
          state.availableGlitches
        );
      }
    }
    return { color, uniqueVariables, variablesToDisplay, parametersToDisplay };
  }

  const blankPanel = PanelElement({
    color: "purple",
    children: [],
    hidden: true,
  });
  let target = state.vm.runtime.targets.find(
    (t) => t.id === state.selectedTargetId
  );
  if (
    state.playingTutorial &&
    state.currentTutorialStep &&
    state.currentTutorial[state.currentTutorialStep].isInterrupt &&
    !state.allowStageVariablesInTutorial
  ) {
    return blankPanel;
  }

  if (!target && !state.selectedGlitchId) {
    target = state.vm.runtime.getTargetForStage();
    if (!target || (state.playingTutorial && !state.allowStageVariablesInTutorial)) {
      return blankPanel;
    }
  }
  let color = "purple";
  let uniqueVariables = [];
  let variablesToDisplay = [];
  let parametersToDisplay = [];
  if (target) {
    const variablesAndParameters = getInputPanelDataForTarget();
    color = variablesAndParameters.color;
    uniqueVariables = variablesAndParameters.uniqueVariables;
    variablesToDisplay = variablesAndParameters.variablesToDisplay;
    parametersToDisplay = variablesAndParameters.parametersToDisplay;
  } else if (state.selectedGlitchId) {
    const variablesAndParameters = getInputPanelDataForGlitch();
    variablesToDisplay = variablesAndParameters.variablesToDisplay;
    parametersToDisplay = variablesAndParameters.parametersToDisplay;
    color = variablesAndParameters.color;
    uniqueVariables = variablesAndParameters.uniqueVariables;
  }

  variablesToDisplay.forEach((v) => {
    if (
      !uniqueVariables.find(
        (uv) =>
          uv.variableName === v.variableName && v.spriteName === uv.spriteName
      )
    ) {
      uniqueVariables.push(v);
    }
  });
  const parameterInputs = parametersToDisplay.map((p) =>
    generateParameterInput(p, target, state, emit)
  );
  let inputs = uniqueVariables.map((gameVariable) => {
    if (!target) {
      return generateInputElement(gameVariable, null, state, emit);
    }
    if (target.sprite.name !== gameVariable.spriteName) {
      const spriteTarget = state.vm.runtime.targets.find(
        (t) => t.sprite.name === gameVariable.spriteName
      );
      return generateInputElement(gameVariable, spriteTarget, state, emit);
    }
    return generateInputElement(gameVariable, target, state, emit);
  });

  // Prepend "Targeting me" list when a concrete sprite is selected
  let targetingBlocks = [];
  if (target && !target.isStage) {
    const blocks = renderTargetingBlock(target);
    if (blocks && blocks.length) targetingBlocks = blocks;
  }

  // Add check for no stickers


  let lastItemHelp = false;
  inputs = targetingBlocks.concat(parameterInputs).concat(inputs);
  if (
    state.playingTutorial &&
    !state.selectedGlitchApplicationId &&
    !state.selectedGlitchId &&
    !state.allowStageVariablesInTutorial
  ) {
    inputs = [];
  }
  const items = paginateInputs(inputs);
  if (state.selectedGlitchApplicationId || state.selectedGlitchId) {
    let glitch;
    if (state.selectedGlitchApplicationId) {
      const glitchApplication = state.glitchApplications.find(
        (g) => g.id === state.selectedGlitchApplicationId
      );

      glitch = state.availableGlitches.find(
        (g) => g.id === glitchApplication.glitchId
      );
    } else {
      glitch = state.availableGlitches.find(
        (g) => g.id === state.selectedGlitchId
      );
    }
    lastItemHelp = true;
    const info = glitch.info[0];
    const glitchHelpItem = html`
      <div class="info">
        <img src="/${info.image}" />
        ${html([info.text])}
      </div>
    `;
    items.push(glitchHelpItem);
  }

  if (
    state.currentVariablePage === undefined ||
    state.currentVariablePage > items.length - 1
  ) {
    state.currentVariablePage = Math.max(0, items.length - 1);
  }
  let variablePage = state.currentVariablePage;
  if (state.selectedGlitchId)
    if (
      state.selectedVariablePagesForGlitches &&
      (state.selectedVariablePagesForGlitches[state.selectedGlitchId] ||
        state.selectedVariablePagesForGlitches[state.selectedGlitchId] === 0)
    ) {
      variablePage =
        state.selectedVariablePagesForGlitches[state.selectedGlitchId];
    } else {
      variablePage = items.length - 1;
    }

  return PanelElement({
    color,
    children: [
      CarouselElement({
        selectedItem: variablePage,
        lastItemHelp,
        items,
        disabled: state.selectedVariableId !== null || state.isMenuOpen,
        onChange: state.selectedVariableId
          ? () => false
          : (index) => {
              emit("select-variable-page", index, state.selectedGlitchId);
              if (lastItemHelp && index === items.length - 1) {
                emit("select-glitch-help-page");
              }
            },
      }),
    ],
    id: "variables-panel"
  });
};
